import { render, staticRenderFns } from "./walletSecretConfirm.popup-chunk.vue?vue&type=template&id=3de01038&scoped=true"
import script from "./walletSecretConfirm.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./walletSecretConfirm.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./walletSecretConfirm.popup-chunk.vue?vue&type=style&index=0&id=3de01038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de01038",
  null
  
)

export default component.exports